import { useEffect, useState } from "react";
import NomineeDetails from "../investors/nomineeDetails";
import { getApplicationDetails } from "../../redux-store/actions/application";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { showError } from "../../redux-store/actions/auth";
import { Box, LinearProgress, Skeleton, Typography, useTheme } from "@mui/material";
import { USER_ROLES } from "../../utils/constant";
import { ApplicationProps } from "../../redux-store/types/api-types";
import { isRMLikeRole } from "../../utils/utilityFunctions";

type typeLocation = Location & { state: { applicationId: string } }
export function addEditNominee(): JSX.Element {
    const history = useHistory();
    const dispatch = useDispatch();
    const theme = useTheme();
    const { role = "" } = useSelector((state: any) => state.auth);
    const [application, setApplication] = useState<Partial<ApplicationProps>>({});
    const [isApplicationLoading, setIsApplicationLoading] = useState<boolean>(false);

    const { state: { applicationId } } = history.location as typeLocation;

    useEffect(() => {
        (async () => {
            try {
                setIsApplicationLoading(true);

                const res = await dispatch(getApplicationDetails(applicationId)) as unknown as ApplicationProps;
                if (!res) {
                    dispatch(showError('Application not found'));
                    return;
                }
                setApplication(res);
            } catch (e) {
                console.error((e as Error).message);
            } finally {
                setIsApplicationLoading(false);
            }
        })();
    }, [applicationId]);

    return (
        <Box
            sx={{
                p:{xs:"15px", sm:"25px"},
                bgcolor: "background.paper",
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                borderRadius: '25px',
                minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
            }}>
            {isRMLikeRole(role) && (
                <Box sx={{ width: "100%", marginTop:{ xs:"0px",sm:"30px"}, display: "flex", justifyContent: "flex-start" }}>
                    <Typography variant="h3" sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>Selected Investor*: {isApplicationLoading ? <Skeleton width={180} /> : application?.applicants?.[0]?.name}</Typography>
                </Box>
            )}
            <Box sx={{ marginTop: { xs: "10px", sm: "30px" } }}>

                {isApplicationLoading ? <LinearProgress /> :
                    <NomineeDetails isDirect applicationId={applicationId} />
                }
            </Box>

        </Box>
    )
}